import { atom } from "recoil";
import { AccountDetailsState } from "./CampaignsTrendingDomains.types";

export const accountDetailsAtom = atom<AccountDetailsState | undefined>({
  key: `accountDetailsAtom`,
  default: undefined,
});
